import React from 'react'
import BlogPost from './BlogPost'

export default function BlogListing({initialData}) {
  return (
    <>
      <BlogPost  initialData={initialData}/>
    </>
  )
}
